import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import DeskRemoveIcon from "assets/icons/bookr.svg?react";
import { useOnClickOutside } from "usehooks-ts";
import { useEffect, useRef } from "react";

const DeskActiveModal: FC<Props> = ({ toggle, onRemove }) => {
  const ref = useRef(null);
  useOnClickOutside(ref, () => {
    toggle(false);
  });

  const handleMouseMove = (event) => {
    const position = ref.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    event.clientY + position.height > windowHeight;
  };

  useEffect(() => {
    const currentEvent = window.event;
    if (currentEvent) {
      handleMouseMove(currentEvent);
    } else {
      // If no event available, add listener to capture the next move
      window.addEventListener("mousemove", handleMouseMove, { once: true });
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div ref={ref} className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.title}></div>
        <div
          onClick={(e) => {
            onRemove();
            toggle(false);
            e.preventDefault();
            e.stopPropagation();
          }}
          className={styles.box}
        >
          <DeskRemoveIcon />
          Odepnij z biurka
        </div>
      </div>
    </div>
  );
};

export default DeskActiveModal;
